<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
        
      </b-col>
        <div v-if="car" class=" text-left w-100 mt-1 ml-1">{{`${car.name} | ${car.city.name}`}}</div>
      <!-- Content Right -->
      <b-col v-if="this.calender" class="content-header-right text-md-right" md="12" cols="12">
        
        <CalendarMonth
          ref="calender"
          @showSidebar="showFormModal"
          :residenceAvailabelDates="calender"
          :similar-unit="Number(this.car.similar_unit)"
          @closeSideBar="closeSideBar"
          :peak-dates="peakDates"
          :peak-pric="Number(this.car.prices.peack_days)"
        />
      </b-col>
    </b-row>
    <b-sidebar
      width="500px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">تغییرات را انتخاب و اعمال کنید.</h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="fullOrEmptyOptions" class="text-capitalize"
            >پر / خالی</label
          >
          <v-select
            id="fullOrEmptyOptions"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            v-model="calenderInput.fullOrEmptyOptions"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="label"
            :reduce="(option) => option.name"
            :options="fullOrEmptyOptions"
          ></v-select>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="special_day_price" class="text-capitalize"
            >نرخ گذاری روزهای خاص:
          </label>
          <b-form-input
            id="special_day_price"
            v-model="calenderInput.price"
            type="text"
          />
        </b-form-group>
        <!-- <b-form-group class="mt-1">
          <label for="extra_guest_price" class="text-capitalize"
            >هزینه نفرات اضافه:
          </label>
          <b-form-input
            id="extra_guest_price"
            v-model="calenderInput.extra_guest_price"
            type="text"
          />
        </b-form-group> -->
        <b-form-group class="mt-1">
          <label for="instant" class="text-capitalize">آنی/ غیرآنی</label>
          <v-select
            id="instant"
            :components="{ OpenIndicator }"
            class="bg-white"
            :clearable="false"
            v-model="calenderInput.instant"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="label"
            :reduce="(option) => option.name"
            :options="instantOptions"
          ></v-select>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="discount" class="text-capitalize"> %تخفیف: </label>
          <b-form-input
            id="discount"
            v-model="calenderInput.discount"
            type="text"
          />
        </b-form-group>
        <!-- <b-form-group class="mt-1">
          <label for="min-night" class="text-capitalize mr-1">
            حداقل مدت اقامت :
          </label>

          <b-form-spinbutton
            inline
            id="min-night"
            min="1"
            v-model="calenderInput.minNight"
          ></b-form-spinbutton>
        </b-form-group> -->
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="
              () => {
                (formModal = false), ($refs.calender.showTop = true);
              }
            "
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIconCalendar,
  BAlert,
  BFormSpinbutton,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import CarWizard from "@/components/CarWizard.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import { forEach } from "postcss-rtl/lib/affected-props";
import CalendarMonth from "@/components/calender/CalendarMonth";

export default {
  components: {
    CarWizard,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BIconCalendar,
    CalendarMonth,
    BAlert,
    BFormSpinbutton,
  },
  data() {
    return {
      peakDates:[],
      calender: null,
      formModal: false,
      fullOrEmptyOptions: [
        { name: "none", label: "بدون تغییر" },
        { name: "empty", label: "همه اقامتگاه ها خالی هستند" },
      ],
      instantOptions: [
        { name: "instant", label: "آنی" },
        { name: "non_instantaneous", label: "غیرآنی" },
      ],
      calenderInput: {
         fullOrEmptyOptions: "none",
        instant: "non_instantaneous",
        minNight: null,
        price: "",
        extra_guest_price: "",
        discount: "",
        minNight: "",
      },
      submitLoading: false,
      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      date: {
        books_count: 1,
        date: "2022-11-20",
        disable_count: 0,
        is_custom_price: 1,
        price: 700000,
      },
      car: null,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);

    this.getCarCalendar();
    this.getCar();
    this.getPeakCalender()
  },
  watch: {},
  computed: {},

  methods: {
     async getPeakCalender() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      

      const requestData = {
        method: "get",
        url: "/admin/courier_calendars",
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data.data[0].data;
          this.peakDates = data;
          console.log("this.peakDates",this.peakDates)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeSideBar(){
this.formModal = false;
this.calenderInput= {
        fullOrEmptyOptions: "none",
        instant: "non_instantaneous",
        minNight: null,
        price: "",
        extra_guest_price: "",
        discount: "",
        minNight: "",
      },
this.getCarCalendar();
    },
    showFormModal() {
      this.formModal = true;
      this.$refs.calender.showTop = false;
    },

    async getCarCalendar() {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/car/calendars/${this.$route.params.id}`,
        // cancelToken: this.cancelToken.token,
      };
      await this.$http(requestData)
        .then((response) => {
          let data = response.data;
          console.log('tagh:',data)
          this.calender = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
   async getCar() {
      if (typeof this.provincesCancelToken != typeof undefined) {
        this.provincesCancelToken.cancel(
          "Operation canceled due to new request."
        );
      }
      //Save the cancel token for the current request
      this.provincesCancelToken = this.$http.CancelToken.source();

      let data = {
        paginate: false,
        //  this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: `/admin/cars/${this.$route.params.id}`,
        // cancelToken: this.cancelToken.token,
      };
     await this.$http(requestData)
        .then((response) => {
          let data = response.data;
          
          this.car = data.data;
          console.log("this.car:",this.car)
          this.createFullOrNotOptions(this.car.similar_unit);
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createFullOrNotOptions(similar_unit) {
      var option = [
        { name: "none", label: "بدون تغییر" },
        { name: "0", label: "همه اقامتگاه ها خالی هستند" },
      ];
      var index = 1;
      while (index <= Number(similar_unit)) {
        option.push({ name: index, label: `${index} اقامتگاه پر است` });
        index = index + 1;
      }
      this.fullOrEmptyOptions = option;
    },
    submitForm() {
      var dataToedit = {};
      if (this.calenderInput.fullOrEmptyOptions == "none") {
      } else {
        dataToedit["disable_count"] = Number(
          this.calenderInput.fullOrEmptyOptions
        );
      }
      if (this.calenderInput.price) {
        dataToedit["price"] = Number(this.calenderInput.price);
        dataToedit["is_custom_price"] = 1;
      }
      // if (this.calenderInput.extra_guest_price) {
      //   dataToedit["extra_guest_price"] = Number(this.calenderInput.extra_guest_price);
      // }
      if (this.calenderInput.instant) {
        dataToedit["instant"] = this.calenderInput.instant;
      }
      if (this.calenderInput.discount) {
        dataToedit["discount"] = Number(this.calenderInput.discount);
      }
      // if (this.calenderInput.minNight) {
      //   dataToedit["minNight"] = this.calenderInput.minNight;
      // }

      this.$refs.calender.dataToedit = dataToedit;
      console.log("dataToedit:",dataToedit)
      this.$refs.calender.carId=this.car.id
      this.$refs.calender.setData('car',this.car.id);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
